import { StatePill } from "@ficatranquilo/contabilidade.com-ui";

const ROLE_LABEL = { ADM: "Admin", EMP: "Colaborador" };

/** Papel da pessoa na empresa: no drawer "Minhas Empresas" e na seleção de empresa. */
export default function RoleTag({ role }) {
  return <StatePill $text={ROLE_LABEL[role] || role} $variant="gray" $size="small" />;
}
